<template>
  <div class="root" @click="save()">
    <v-stage ref="windRoseArea" :config="{ width: 150, height: 150, draggable: false }">
      <v-layer>
        <url-image
          imageUrl="/compas.png"
          :config="{
            rotation: windRose.rotation,
            x: 80,
            y: 80,
            width: 130,
            height: 130,
            offsetX: 65,
            offsetY: 65,
            draggable: true,
            dragBoundFunc(pos) {
              windRoseRotate(getScaledPointerPosition().x, getScaledPointerPosition().y);
              return {
                x: 80,
                y: 80,
              };
            },
          }"
        />
      </v-layer>
    </v-stage>
  </div>
</template>

<script>
import UrlImage from "./mapEditor/UrlImage.vue";
export default {
  name: "mapeditor",
  props: {
    project: Object,
  },
  created() {},
  watch: {
    "project.rotate"() {
      this.windRose.rotation = this.project.rotate;
    },
    "windRose.rotation"() {
      this.$emit("rotation", this.windRose.rotation);
    },
  },
  components: {
    UrlImage,
  },
  data() {
    return {
      windRose: {
        rotation: 0,
      },
    };
  },
  methods: {
    save() {
      this.project.rotate = this.windRose.rotation;
      this.$http
        .post("projects/rotate-update?id=" + this.project.id, { rotate: this.windRose.rotation })
        .then(() => {})
        .catch((e) => {
          alert("Ошибка", e);
        });
    },
    windRoseRotate(x, y) {
      let base = { x: 80, y: 80 };
      let angle = Math.PI + Math.atan2(-x + base.x, y - base.y);
      this.windRose.rotation = (angle * 180) / Math.PI;
    },
    getScaledPointerPosition(ev) {
      if (this.$refs.windRoseArea) {
        var stage = this.$refs.windRoseArea.getStage();
        stage.setPointersPositions(ev);
        var pointerPosition = stage.getPointerPosition();
        var stageAttrs = stage.attrs;
        if (!stageAttrs.x) {
          stageAttrs.x = 0;
        }
        if (!stageAttrs.y) {
          stageAttrs.y = 0;
        }
        var x = pointerPosition.x - stageAttrs.x;
        var y = pointerPosition.y - stageAttrs.y;
        return { x: x, y: y };
      }
    },
  },
};
</script>
